import script from "./AchievementsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AchievementsPage.vue?vue&type=script&setup=true&lang=ts"

import "./AchievementsPage.vue?vue&type=style&index=0&id=622e42fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-622e42fc"]])

export default __exports__